<template>
  <ul>
    <li>
      <sprite name="iconCalendar" title="Due Date" />
      Due {{ $moment(blast.dueDate).fromNow() }}
    </li>
    <li>
      <sprite name="iconProfile" title="Assigned By" />
      {{ $_.get(blast, 'assignment.assignedBy') }}
    </li>
    <li>
      <sprite name="iconBlast" title="Assignment Type" />
      {{ blast.assignmentType }}
    </li>
    <li v-if="blast.isReview">
      <sprite name="iconReview" title="Review Mode" />
      Review Mode
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'blastLabels',
    props: {
      blast: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
    display:flex; flex-wrap:wrap;
  }

  li {
    display:flex; align-items:center; margin:.5rem 1.5rem 0 0; font-size:80%;
  }

  svg {
    @include size(1.5rem);
    margin-right:1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/blast-labels.vue